import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

const EUCountryCard = props => {

    const [firstPercentage, setFirstPercentage] = useState('');
    const [secondPercentage, setSecondPercentage] = useState('');
    const [thirdPercentage, setThirdPercentage] = useState('');
    const [fourthPercentage, setFourthPercentage] = useState('');
    const [fifthPercentage, setFifthPercentage] = useState('');
    const [sixthPercentage, setSixthPercentage] = useState('');

    useEffect(() => {
        if (props.euData != undefined)
        {
            if (props.page == 'socialDialogue') 
            {
                setFirstPercentage( percentageHtml( props.euData.data.indicator1 ) );
                setSecondPercentage( percentageHtml( props.euData.data.indicator2 ) );
                setThirdPercentage( percentageHtml( props.euData.data.indicator3 ) );
                setFourthPercentage( percentageHtml( props.euData.data.indicator4 ) );
            } else {
                setFirstPercentage( percentageHtml( props.euData.data["Job satisfaction"] ) );
                setSecondPercentage( percentageHtml( props.euData.data["Health affected by work"] ) );
                setThirdPercentage( percentageHtml( props.euData.data["Health problem in the last 12 months"] ) );
                setFourthPercentage( percentageHtml( props.euData.data["More than 15 days of absence"] ) );
                setFifthPercentage( percentageHtml( props.euData.data["Sick at working"] ) );
                setSixthPercentage( percentageHtml( props.euData.data["Be able to do current job until 60 years old"] ) );
            }
        }
    }, [props.euData] )

    const percentageHtml = (percentage) => {
        if (percentage != null)
        {
            return (
                <div className="group-data">                
                    <span className="country-data">{Math.round(percentage)}</span>
                    <span className="data-text">%</span>
                </div>
            )
        }
        else
        {
            return (
                <div className="group-data">                
                    <span className="country-data">-</span>
                </div>
            )
        }

    }    

    let indicators = [ props.literals.L314, props.literals.L315, props.literals.L316, props.literals.L317, props.literals.L318, props.literals.L319];

    let socialDialogueLink = "";
    if (props.page == 'socialDialogue' && props.euData != null)
    {
        indicators = [ props.literals.L20659, props.literals.L20660, props.literals.L20661, props.literals.L20662 ]
        socialDialogueLink = <p className="download-report" >
                <a href={"/osh-barometer/osh-steering/social-dialogue/Social_Dialogue_"+props.euData.countryName+".pdf"} className="download-pdf" target="_blank">
                    {ReactHtmlParser(props.literals.L20637)}
                </a>
            </p>
    }

    return(
        <div className="highlited--data--section">
            <div className="highlited--data--block container">
                <div className="highlited-data-item">
                    <div className="flags--wrapper">
                    <img src={require("../../../style/img/flag/eu28.png")} width="94px" />
                    </div>
                    <div className="eu-data">
                        <h2 className="country title-section main-color">{ props.literals.L822 }</h2>
                        { socialDialogueLink }
                    </div>
                </div>
                <div className="highlited-data-item">
                    <ul className="highlited-data-list">
                        <li>
                            { firstPercentage }
                            <label>{ indicators[0] }</label>
                        </li>
                        <li>
                            { secondPercentage }
                            <label>{ indicators[1] }</label>
                        </li>
                        <li>
                            { thirdPercentage }
                            <label>{ indicators[2] }</label>
                        </li>
                        <li>
                            { fourthPercentage }
                            <label>{ indicators[3] }</label>
                        </li>

                        {props.page != 'socialDialogue' && (
                            <React.Fragment>
                                <li>
                                    { fifthPercentage }
                                    <label>{ indicators[4] }</label>
                                </li>
                                <li>
                                    { sixthPercentage }
                                    <label>{ indicators[5] } *</label>
                                </li>
                            </React.Fragment>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default EUCountryCard;